import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/data/site";

export default function Process() {
  const steps = SITE.process;

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-brand-bg py-24 lg:py-32 border-t border-brand-border overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-brand-accent">Jak to děláme</div>
            <h2 className="mt-4 font-display font-black text-4xl lg:text-6xl leading-[1.05] tracking-tight max-w-2xl">
              Čtyři kroky.{" "}
              <span className="italic font-light">Profesionální nástroje.</span>
            </h2>
          </div>
          <p className="max-w-md text-brand-muted text-sm lg:text-base">
            Žádné kartáče, žádné zkratky. Každý krok děláme rukama a technikou, kterou používají
            profesionální detaileři — proto lak nepoškrábeme a výsledek vydrží.
          </p>
        </div>

        <div className="space-y-px bg-brand-border">
          {steps.map((s, i) => (
            <motion.article
              key={s.n}
              data-testid={`process-step-${s.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: 0.05 }}
              className={`grid lg:grid-cols-12 bg-brand-bg group ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}
            >
              <div className="lg:col-span-5 relative aspect-[16/10] lg:aspect-auto lg:min-h-[340px] overflow-hidden">
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-[1200ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <div className="absolute left-5 bottom-5 lg:left-7 lg:bottom-7">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-brand-accent mb-1">Nástroj</div>
                  <div className="font-display font-bold text-base lg:text-lg">{s.tool}</div>
                </div>
              </div>

              <div className="lg:col-span-7 p-7 lg:p-12 flex flex-col justify-center">
                <div className="flex items-center gap-5">
                  <span className="font-display font-black text-4xl lg:text-5xl text-brand-accent leading-none">
                    {s.n}
                  </span>
                  <span className="h-px flex-1 bg-brand-border" />
                  <span className="text-xs uppercase tracking-[0.25em] text-brand-muted whitespace-nowrap">
                    {s.duration}
                  </span>
                </div>
                <h3 className="mt-5 font-display font-black text-2xl lg:text-3xl tracking-tight">{s.title}</h3>
                <p className="mt-3 text-brand-muted leading-relaxed max-w-xl">{s.text}</p>
                <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-2">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-sm text-white/90">
                      <span className="mt-2 w-1.5 h-1.5 bg-brand-accent shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
